import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Tab, TabPanel, Tabs, TabsList } from 'base-ui'

import { useProductPageOdsContext } from '../../ods/components/productPageODSContext'
import { useProductPageContext } from '../productPageContext'

import { ProductPageOdsDialogButtonsGroup } from './ProductPageOdsDialogButtonsGroup'
import { ProductPageOdsDialogFeatureDescription } from './ProductPageOdsDialogFeatureDescription'
import { ProductPageOdsDialogHeader } from './ProductPageOdsDialogHeader'
import { ProductPageOdsDialogLocalDoctorSection } from './ProductPageOdsDialogLocalDoctorSection'
import {
  ProductPageOdsDialogOnlineDoctorSection,
  ProductPageOdsDialogOnlineDoctorSectionBilling,
  ProductPageOdsDialogOnlineDoctorSectionNotice,
  ProductPageOdsDialogOnlineDoctorSectionSteps,
  ProductPageOdsDialogOnlineDoctorSectionTitle,
} from './ProductPageOdsDialogOnlineDoctorSection'

export const ProductPageOdsDialogContent: FC = () => {
  const { experimentOdsV1Enabled, videoConsultation } =
    useProductPageOdsContext()
  const { productPageOdsConfig } = useProductPageContext()

  if (!productPageOdsConfig) {
    return null
  }

  const isVideoConsultationAndExperimentOdsV1Enabled =
    videoConsultation && experimentOdsV1Enabled

  return (
    <>
      <ProductPageOdsDialogHeader
        title={
          isVideoConsultationAndExperimentOdsV1Enabled ? (
            <FormattedMessage id="pdp.buyboxwithvariants.odsModalVC.header" />
          ) : (
            <FormattedMessage id="pdp.buyboxwithvariants.odsModal.header" />
          )
        }
      >
        <ProductPageOdsDialogFeatureDescription
          isVideoConsultationAndExperimentOdsV1Enabled={
            isVideoConsultationAndExperimentOdsV1Enabled
          }
        />
        <ProductPageOdsDialogButtonsGroup
          onlineDoctorServiceLink={
            isVideoConsultationAndExperimentOdsV1Enabled &&
            productPageOdsConfig.videoConsultationLink
              ? productPageOdsConfig.videoConsultationLink
              : productPageOdsConfig.odsLandingPageForProduct
          }
        />
      </ProductPageOdsDialogHeader>

      <div className="mt-10">
        <Tabs defaultValue={0}>
          <TabsList>
            <Tab>
              <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab1.title" />
            </Tab>
            <Tab>
              <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab2.title" />
            </Tab>
          </TabsList>
          <TabPanel>
            <ProductPageOdsDialogOnlineDoctorSection>
              <ProductPageOdsDialogOnlineDoctorSectionTitle />
              <ProductPageOdsDialogOnlineDoctorSectionSteps />
              <ProductPageOdsDialogOnlineDoctorSectionNotice />
              <ProductPageOdsDialogOnlineDoctorSectionBilling />
            </ProductPageOdsDialogOnlineDoctorSection>
          </TabPanel>
          <TabPanel>
            <ProductPageOdsDialogLocalDoctorSection />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}
